// ****** rtTabs ******//
// Title: tabs
// Version: 1.1
// Description: Provides a simple tab set up.
// Dependencies: jQuery, rtlib
// Authors: Rory Saxby
// Notes: 1.1 added accordion responsive functionality
// Example

/*$(document).ready(function(){

    var selectBoxTabs = new logicjs.tabs({
        viewsContainer: '#selectBoxTabsViews',
        view: '.tabs-switcher__view',
        tabsContainer: '#selectBoxTabs',
        hiddenViewClass: 'tabs-switcher__view--hidden',
        addSelectBox: true,
        selectBoxClass: 'tabs-switcher__select-box',
        selectBoxActiveClass: 'tabs-switcher__select-box--active',
        tabsCtrlDisplayClass:'active'
    });

});*/

// <section id="rtTabs"></section>
// <section id="rtTabViews">
// 		<div class="view" data-tab-title="example title 1">
//			<!------ markup/content ----->
//		</div>
// 		<div class="view" data-tab-title="example title 2">
//			<!------ markup/content ----->
//		</div>
// 		<div class="view" data-tab-title="example title 3">
//			<!------ markup/content ----->
//		</div>
// </section>

if (typeof logicjs === "undefined") var logicjs = {};

logicjs.tabs = function (opts) {
    this.opts = {};
    this.opts.viewsContainer = $(opts.viewsContainer);
    this.opts.view = opts.view || 'div';
    this.opts.views = this.opts.viewsContainer.find(this.opts.view);
    this.opts.tabsContainer = $(opts.tabsContainer);

    this.opts.activeTabClass = opts.activeTabClass || 'active-tab';
    this.opts.hiddenViewClass = opts.hiddenViewClass || 'hidden-view';
    this.opts.selectBoxClass = opts.selectBoxClass || 'select-box';
    this.opts.selectBoxActiveClass = opts.selectBoxActiveClass || 'active';
    this.opts.tabsCtrlDisplayClass = opts.tabsCtrlDisplayClass || 'hidden';

    this.opts.startAt = (opts.startAt - 1) || 0;
    this.opts.loadHidden = opts.loadHidden || false;
    this.opts.toggleHide = opts.toggleHide || false;
    this.opts.addSelectBox = opts.addSelectBox || false;
    this.opts.addAccordionButtons = opts.addAccordionButtons || false;

    this.opts.currentIndex = this.opts.startAt;

    if (this.opts.viewsContainer.length > 0 || this.opts.tabsContainer.length > 0) {
        this.init();
    };
};

logicjs.tabs.prototype.buildTabs = function () {
    this.opts.tabsContainer.append('<ul></ul>');
    this.opts.tabListContainer = this.opts.tabsContainer.find('ul');

    for (var i = 0; i < this.opts.views.length; i++) {
        if (this.opts.views[i].attributes['data-tab-class'] !== undefined && this.opts.views[i].attributes['data-tab-class'].value !== null) {
            var tab = '<li><button class="' + this.opts.views[i].attributes['data-tab-class'].value + '" type="button">' + this.opts.views[i].attributes['data-tab-title'].value + '</button></li>';
        } else {
            var tab = '<li><button type="button">' + this.opts.views[i].attributes['data-tab-title'].value + '</button></li>';
        };

        this.opts.tabListContainer.append(tab);

        // Add additional tab for accordion view REQUIRES UPDATE
        if (this.opts.addAccordionButtons) {
            //$(this.opts.views[i]).parents(this.opts.viewContainerClass).prepend(tab);
        };
    };
};

logicjs.tabs.prototype.addSelectBoxView = function () {
    this.opts.tabsContainer.prepend('<div class="' + this.opts.selectBoxClass + '">Please select</div>');
    this.opts.selectBox = this.opts.tabsContainer.find('.' + this.opts.selectBoxClass);
};

logicjs.tabs.prototype.bindSelectBox = function () {
    var _ = this;

    $(this.opts.selectBox).off('click.selectbox').on('click.selectbox', function () {
        _.toggleTabsDisplay();
    });
};

logicjs.tabs.prototype.toggleTabsDisplay = function () {
    if (this.opts.tabListContainer.hasClass(this.opts.tabsCtrlDisplayClass)) {
        this.opts.tabListContainer.removeClass(this.opts.tabsCtrlDisplayClass);
        this.opts.selectBox.removeClass(this.opts.selectBoxActiveClass);
    } else {
        this.opts.tabListContainer.addClass(this.opts.tabsCtrlDisplayClass);
        this.opts.selectBox.addClass(this.opts.selectBoxActiveClass);
        this.bindDocument();
    };
};

logicjs.tabs.prototype.bindDocument = function () {
    document.addEventListener('mousedown', this.handleClick.bind(this));
};

logicjs.tabs.prototype.handleClick = function (e) {
    e.stopImmediatePropagation();

    var target = $(e.target);
    if (target.hasClass(this.opts.selectBoxClass) || target.parents(this.opts.tabListContainer).hasClass(this.opts.tabsCtrlDisplayClass)) {
        document.removeEventListener('mousedown', this.handleClick);
    } else {
        this.opts.tabListContainer.removeClass(this.opts.tabsCtrlDisplayClass);
        this.opts.selectBox.removeClass(this.opts.selectBoxActiveClass);
        document.removeEventListener('mousedown', this.handleClick);
    };
};

logicjs.tabs.prototype.addSelectBoxViewValue = function () {
    this.opts.selectBox.text(this.opts.views[this.opts.currentIndex].attributes['data-tab-title'].value);
};

logicjs.tabs.prototype.updateSelectBox = function () {
    this.toggleTabsDisplay();
    this.addSelectBoxViewValue();
};

logicjs.tabs.prototype.bindTabs = function () {
    this.opts.tabs = this.opts.tabsContainer.find('button');

    var _ = this;

    this.opts.tabs.off('click.tab').on('click.tab', function () {
        _.resetAll();
        var index = $(this).parent().index();
        // If toggleHide is enabled check same index 
        if (_.opts.toggleHide) {
            _.checkSameIndex(index);
        } else {
            _.activateView(index);
        };

        if (_.opts.addSelectBox) {
            _.updateSelectBox();
        };
    });
};

logicjs.tabs.prototype.checkSameIndex = function (index) {
    if (this.opts.currentIndex !== index) {
        this.activateView(index);
    } else {
        this.opts.currentIndex = -1;
    };
};

logicjs.tabs.prototype.resetAll = function () {
    for (var i = 0; i < this.opts.tabs.length; i++) {
        $(this.opts.tabs[i]).removeClass(this.opts.activeTabClass);

        var selectedView = $(this.opts.views[i]);

        //this.setViewMaxHeight(selectedView, 0);

        if (!selectedView.hasClass(this.opts.hiddenViewClass)) {
            selectedView.addClass(this.opts.hiddenViewClass);
        };
    };
};

logicjs.tabs.prototype.activateView = function (index) {
    var selectedView = $(this.opts.views[index]);
    //this.setViewMaxHeight(selectedView, selectedView[0].scrollHeight*2);
    selectedView.removeClass(this.opts.hiddenViewClass);
    $(this.opts.tabs[index]).addClass(this.opts.activeTabClass);
    this.opts.currentIndex = index;
};

logicjs.tabs.prototype.setViewMaxHeight = function (view, height) {
    view[0].style.maxHeight = height + "px";
};

logicjs.tabs.prototype.selectAccordionBtns = function () {
    // REQUIRES UPDATE
    // for (var i = 0; i < this.opts.viewContainers.length; i++) {
    //     var button = $(this.opts.viewContainers[i]).find('> button');
    //     this.bindAccordion(button, i);
    // };
};

logicjs.tabs.prototype.bindAccordion = function (button, index) {
    var _ = this;
    button.off('click').on('click', function () {
        _.resetAll();
        _.activateView(index);
    });
};

logicjs.tabs.prototype.init = function () {

    this.buildTabs();
    this.bindTabs();

    this.resetAll();

    if (!this.opts.loadHidden) {
        this.activateView(this.opts.startAt);
    } else {
        this.opts.currentIndex = -1;
    };

    if (this.opts.addAccordionButtons) {
        this.selectAccordionBtns();
    };

    if (this.opts.addSelectBox) {
        this.addSelectBoxView();
        this.addSelectBoxViewValue();
        this.bindSelectBox();
    };
};